var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageRoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4192_24498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 64,
    height: 64,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#166C79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8359 41.8311C46.0967 41.8311 46.3082 42.034 46.3082 42.2844L45.8359 41.8311Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8359 41.8311C46.0967 41.8311 46.3082 42.034 46.3082 42.2844",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3594 42.2844C45.3594 42.034 45.5708 41.8311 45.8316 41.8311L45.3594 42.2844Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 42.2844C45.3594 42.034 45.5708 41.8311 45.8316 41.8311",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8316 42.738C45.5708 42.738 45.3594 42.535 45.3594 42.2847L45.8316 42.738Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8316 42.738C45.5708 42.738 45.3594 42.535 45.3594 42.2847",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3082 42.2847C46.3082 42.535 46.0967 42.738 45.8359 42.738L46.3082 42.2847Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3082 42.2847C46.3082 42.535 46.0967 42.738 45.8359 42.738",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.668 29.8935C32.668 29.8162 32.7452 29.6846 32.9272 29.6846H49.2976C49.4797 29.6846 49.5569 29.8162 49.5569 29.8935V54.8846H32.668V29.8935ZM32.9272 27.6846C31.7183 27.6846 30.668 28.6354 30.668 29.8935V54.8848H27.8906C27.3383 54.8848 26.8906 55.3325 26.8906 55.8848C26.8906 56.437 27.3383 56.8848 27.8906 56.8848H54.3351C54.8874 56.8848 55.3351 56.437 55.3351 55.8848C55.3351 55.3325 54.8874 54.8848 54.3351 54.8848H51.5569V29.8935C51.5569 28.6354 50.5065 27.6846 49.2976 27.6846H32.9272Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4192_24498",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4192_24498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4192_24498",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRoomIcon);
export default __webpack_public_path__ + "static/media/manage-room-icon.2739b12d6bb00eb548bbeded7c5ce914.svg";
export { ForwardRef as ReactComponent };